import styled from 'styled-components'

export const TableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    background: white;
    border-radius: 16px;
    box-shadow: 0 3px 10px rgba(42, 76, 129, 0.12);
    border: 1px solid #dde6f3;
`

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    thead {
        background: #dfe9f8;
    }

    th {
        padding: 14px 16px;
        text-align: left;
        font-size: 15px;
        color: #355486;
        border-bottom: 1px solid #cfd9ea;
        white-space: nowrap;
    }

    td {
        padding: 14px 16px;
        font-size: 14px;
        color: #2f4c7d;
        border-bottom: 1px solid #e7edf7;
        vertical-align: top;
    }

    tbody tr:hover {
        background: #f8fbff;
    }
`

export const EditingRow = styled.tr`
    background: #f0f6ff;
`

export const ActionsCell = styled.td`
    white-space: nowrap;
`

export const ActionButton = styled.button`
    margin-right: 8px;
    margin-bottom: 4px;
    padding: 8px 12px;
    border: 1px solid #cfd9ea;
    border-radius: 10px;
    background: white;
    color: #355486;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`

export const SaveButton = styled(ActionButton)`
    border-color: #4a6fb0;
    color: #4a6fb0;
`

export const DeleteButton = styled(ActionButton)`
    border-color: #d9534f;
    color: #d9534f;
`
